import { Injectable, Provider } from '@angular/core';
import { AddonFacebookChatScript, AddonFacebookChatService, AddonFacebookScript, AddonGoogleTagManagerScript, AddonGoogleTagManagerService } from '@domains/frontend/page-addons';


@Injectable()
class LegalDummyFacebookScript extends AddonFacebookScript {
	override create(): this { return this; }
}

@Injectable()
class LegalDummyFacebookChatScript extends AddonFacebookChatScript {
	override create(): this { return this; }
}

@Injectable()
class LegalDummyFacebookChatService extends AddonFacebookChatService {
	override show(): void {}
	override hide(): void {}
}

@Injectable()
class LegalDummyGoogleTagManagerScript extends AddonGoogleTagManagerScript {
	override create(): this { return this; }
}

@Injectable()
class LegalDummyGoogleTagManagerService extends AddonGoogleTagManagerService {
	override emitEvent(): void {}
}

export const LEGAL_DUMMY_ADDON_PROVIDERS: Provider[] = [
	{ provide: AddonFacebookScript, useClass: LegalDummyFacebookScript },
	{ provide: AddonFacebookChatScript, useClass: LegalDummyFacebookChatScript },
	{ provide: AddonFacebookChatService, useClass: LegalDummyFacebookChatService },
	{ provide: AddonGoogleTagManagerScript, useClass: LegalDummyGoogleTagManagerScript },
	{ provide: AddonGoogleTagManagerService, useClass: LegalDummyGoogleTagManagerService }
];
